/** Shown when an undo or a move sent a stale token; the history has already reloaded. */
export const IMPORT_CHANGED_ELSEWHERE = 'This import was just changed elsewhere. It has been reloaded, so check it and try again.';
